var _g, _g2, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFemaleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_510_10066)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F4F7FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_510_10066)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 25,
    fill: "#F4F7FF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_510_10066",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_510_10066"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_510_10066",
    x: 3,
    y: 3,
    width: 54,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_510_10066"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_510_10066",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_510_10066"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_510_10066",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_510_10066",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAOF0lEQVR4nO2dfXRU5ZnAf++9k8nMhCRkICEfRIgQ00VsjXUVU1sF21IsUNZi3brbVvDg9lT8osDSc+xa93TPUaFblW1rtaV/sK3LR/GICFWqIBbFxYqofH+EfE8+yCSTzEcyM/fdP5IghCRz78w7E+jO75yck5M87/M88zz33vfrue9AmjRp0qRJkyZNmjRp/r8hRtuBkfB4ugoyDFEpNa0CSYWAChAFILOAPCCrX9QPeEH4kUazFOI4gqPC0I7ZRfhAdlF26+h9ipG5pBLQ2Chddi3wFWGIWQgxE+R0EvdRAh8j2WVo8s1Q2LWztFQEFbirhFFPgJRS8zaFqqTGd5DGP4LISbJFn0C8jJCb8ia4tgshosm1NzKjloDqaunIdQQWS8RyoGyU3DgtkGvyul3rRLnoGQ0HUp6AxkbpyhTBHwDLgKJU2x+GJiRrenA+V1wsAqk0nNIEtHv886QUzwKTU2nXAvXAI+OKXJtTZTAlCfA2BSdHkWsFzE2FvUQRsBUpHnAXO2tTYCu5tDX6Fwgh1tE3bLyMkD4QS8YVuTYm00rSEiBPyMz2rOBTCB5Mlo2UIMTz7i7Hg8nqpJOSAF+9b1xYt20DZiRDf8oR7LWFw/NzS3Pb1atWTGurv1iLaH8CeY1q3aOLPIIhZo8rcdWp1Ko0AW2NPZ8RIvo6UKpS7yVErWFoX80vcRxTpVBZAtrqAiXCxl5gkiqdlySCBs0QX8grdtaoUKepUOKr940TNrmTv/XgA0hKDGFs76zrdKtQl/AdIE/IzPYxwd0kscP1tbdy5thBmmtO0NZURyjoJxTsJuT3E430XiA7b9FyKiqrkuXKp0jecfudsxIdHdkS9cM7JvgzkhD8cG+Iw/v3cHDv67TUnzbd7o1Nz1NaPh3XmCSv6Qmq2rOCTwEPJaYmAc42BRYCmxLRMRgpJR+/+wZ7d7yIv9Mbl46KyirmLVqu0q1hkZJvji92bYm3fdwJ8DYFJxvwIcjceHUMxu/r4NX1T1N77KOEdWXYHWSNdZOdk0dp+XSmfvZGCkqSsAQl6NAMcW28nXLcCWhrCmwVMC/e9oNpbahh868ex+/rUKXyIorLKrh1wT0Ul1Uo1SskL7uLXQviahtPo/71nZfiaTsUzfXVbP7FTwj6u1SpHBYhBJVfup1b/2ERmqZkENivV853F2a9Yrmd1Qb96/mHUTTk9Hd6Wb9mBd2dymf5I1I2rZJvLF6JzZ6pSmV1IOK82up2p+VLwCGC96Mo+NFohJfXPZXy4ANUHz7Ajt+vRUqpSmWZSw/+i9VGlhIgT8hMCQ9bNTIc77+5lcZqZbN6yxw78A7vva5w70WwsrpaOqw0sZQA75jAvUCxJaeGwedtZd9rKdt4GpZ3/7SJsx5l62tFuZmB71lpYDoBUkqtfwNdCX955Q+Ee0Oq1J2jME+waLaN68rNfbRoNMKfNz6vzL4hxAoppem+1fRMuM0TukVTVL3Q2d7C0QN/UaHqHDkuwaxKjeuv0tAETJqgU98qaemI/YyvO3mIuhOfUFo+PWE/BEzpaAp9EdhjRt70HaBhfCdurwbx/q6tGFE15Th2G9xWqbFsoY0bKvqCP/D3b8/UsZu8xPbtjHsyexEGmI6VqQTU1UknaHfE79KnRCJhDv/v7oT1CKByqsYPF9q4rXLoQE/IE8y/STelr/bYQTraPAn71eec8a2+mMXGVAKcGYGvqlpyOHPkAD3BxEpvphZrLF1g484v6WS7Rn7cXleumeoPpJQc3v9WQn59isjJsgVmmZE0lQBhCFPKzHDsg71xtx3oYBd/TafIbX4OOf8mnYKxseUT8W0wEjHTjJy5PkCYUxYLwzA4ffivlttluwR33KyzdIGN8hLrqydm+4OzzfX42hUVUgtuMyMWMwEeT1dBf5VywrQ2VFt6/Ax0sD9caDs3uokXs/1B9dEP4zdyPpLP+hp942OJxUxAhiEqUbR3XHfiE1NyZjrYeDDTFzScPqLGGGi9uv3aWEIxP5rUtAqhaLmk7tThmDLlJYI5N+gU5o1O4ban5qQ6ZUa0AvjzSCKxry2JssXz1oYzMWUWzb7QpY+Ot7Ntd99SwfyZVzC9fOQKR6vyg/G2NBDp7VGySqohYsYu5j0ppLwqYU/o2+Pt8rZZbrdtdx1dgTBdgTBbd8des7EqPxgpJd62ZsvthtQlZOIJQGiFKpxpb25QufSbVDramtQokiJm7EwMQ2W2Cl/ONtfH1W7ezFKys+xkZ9mZf2vsgjur8kPR0aooARAzdmbGF0oSEO/4+ppyN9eUm6+Bsio/FKlMgJmJ2BgFjiR1s1013b74ymEGIxUlQAmBrssnASF/d8psmUmAEm8Cl9EdEAr6legRELPMw0wClNSKBLp9KtSkhFBAWXmMigQIJd6Ee0flNdy4UOirggRIQ8kuRSQSNiVnJHGuYFZ3NKLo5XkhY8YuZgKkEMdV+DK4jHw4drzXqcLckLy6z1w/JI2IEntCipg1NyZmwigp3IlGzH2oZ/7o4UiN+rM0jteH+K8t5pYYZsy+U4lNA5l4AoRhKEmAETWXgJ6wwaPr6mjtUHMVArR4w/zohVpCYSOmbNWcu6iac5caw5qeeALsQn5A35EvCfG1u5eSYTdXNNbWGeH7Pz/N0drE74STDT0sffYMbZ2xE6o0+GDYw70HYgnFTEDfYUfC3E7KCEy74Vb+ecVTjC8ytz7T1hnhobU1bHu3g/jyL3nlXS8/eLqaZm/sAYDi4CPhYM7EnLOx5MzNhKV8M2GPgHETJnL3I0/wmc/fbEo+FDZYvaERmt6GoIW1pFArNO1hzYYmelL92OlHgKmYmdrsMzT5piZFQu9CDWB3OJn7vWWUll/Drs2/MTc87e2Eln1gc4KrCJwFkJENmr3fwV7o7YJQCwSaIDLw6MqPqToZwQcQmLtoTSUgFHbtdNlCnSpfR/pc1VcoumIKW9etpsPsBkgkCL7TfT8KSFbwQXT6I85dZiRNPYL6Xjow/piYUxdTMPFKvrvyZ1z1uZtUq45J8oIPCDaafVHD9GqogbY+fo+Gx+5wMW/xcmbdsRhd77shp0Tt3BfMY72vhLc6yqBtinXFbVN4q6OM9b4SloTcXBm1n/tXUoMPCAPTsTJdeiCl1No9wRPAlXF5ZQLPlpdwPb+ZyZ5BSyiP6DB2H2B2lpwL3hnw9IVLCtWF2Ry943puvO8RJf4OhYCTeYXOq4QwV0ti+g4QQhgCuSZ+14ZHr20i+/7Hmfbvv7s4+ACnNcidAVpGbGXCBjkz4NTF11aZp4s5v9xF9n2Pop9O0mFYUq42G3ywWHDVfyzBaRS9JUPUwPnCBpy/2QQjLVVMFvATB3R0gm8vyGEWy4QOOV+AsbnwWA/UjDAEzcggeO9CgkvuAl3ZvlS9u9s51crxBZYs9yv+T8tuDaWrs4uc+x7F+dyLIwcf4IwEj+wL7Lgq0Ieo2dEdkN8f/CY5cvABwmGcz71I9vf/DeFTswMmBautnh1hOfU90vkrIHaF1UhGm9vIuWcVtr9amGC/0Z+krLFQdAtkT+4Luu6AnLK+vzlzL5Q1Qcb+j8i5ZxVai/WapfORcKor6LT8rlNc9X/tTf45ErE9nraiw0fOPavQz1gsU8kQsDoTYpWZeyWsDIG57YdzRCcV0/W7JzHc8U11BHKuuyjrVavt4nr4uYuydgjYarlhJEr2w/9hPfgAYQm/7oWRniwS+G3YcvAB9JpGxix/AqKxly4uQvBSPMGHRKoipHgAgaWdduev/wfbhwlUHx8xYEN46LU5CfwhDJ/Ev5tl++AQzhc2WG3mJRr/kTUJlSC3e/xzpRRbzejRq+vIvfNBULHd93c6fF2Hqf3Xz0kJ28JwNI6rdzA2nc4NzxCdcoUZadl/XE3c52YkXAN+tjHwjJmzQbPvf5yMvdbfjhkNwrf8PV3P/Di2oODn4wpdyxKxlfAA2O13rkTyzkgy+vEzl03wATLe2o9+MuZE7W33WeeqRG0lnABRLnqEI3Q7koPDyTg2xjVgGlUyN+8Y4b/ikC0SXiCuFuYqDUZAyRTQ7XZ3yihfBy4+NcqQ2N8Y8Qa5JLHv3AtDl7HUC8ntqk7RVTYHH1/qajAMbTZwwb1rO3oK4b18quIG0M52oB+/aL5Za0S121Seqq60ODe/xHHMsMkZwLlD3yzNdi8xMt4/33d5GIOb8yc6lNRJDaC8Ojo/P6vJFgnPHOiY9ZpG1SZShl7TMPDr23pv+GbV50ZDksrTc0tz291FzlskPKnVKXvZIeVotY0gedbd7vzy2Elj1bw0MNhGMpQCCCEi44tcqyJV166ITixUMENKLUZhvhH+/LTHxhW7HlIx2hmOlLyM27VxzzT7lte323e/N2mYkcWlgxD0zppR3TN31u05d888mnRzyTZwPqEn//thfcfbT9iOnFJ2VKFKolMn9/TOvPHHrp8uWZ0qmyl/Hd3zmicrd/uLL9j37L9Ta2xRdAhBYhglBZHeL96w0fvlby0pnlf8t/s1VucjV7+WFao5tDbj/Y/+Sa+ut8duoR7jytKe3uun/95RdtNSsaxqVL7ecNS/yhAg+NDT39Vr6lfYPj52tegOJtUnOcYlw9dNOxm9euqzzsfu/YWVDfRkcEkkYIDWJ1/Ozmmre0DUNn5TP1U3TWvwODASjI8miJYUhoypVxyKlkzY0l0waW3+v34j+Wckm+SSSsBggqs3lsnmloW6p7WKYHCq7gsWCm/HGBEM2Qj16CLUIwCkI1PiyIxKpyNi5I3tNnKcHpzOk7Jg/F6ZP36z80ffTmgPO02aNGnSpEmTJk2aNGlU8n9vJw80tRv17gAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIcon);
export default __webpack_public_path__ + "static/media/FemaleIcon.8bd9d2b2932fbed6bf1c6eba988efd21.svg";
export { ForwardRef as ReactComponent };